var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD28SocialNavercafe = function SvgD28SocialNavercafe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EFEFF3",
    cx: 14,
    cy: 14,
    r: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.915 15.712h-1.122c-.216 1.196-1.052 3.639-4.263 3.639-4.252 0-4.34-4.284-4.34-4.284v-2.573a.14.14 0 0 1 .141-.141h9.584a1.68 1.68 0 0 1 1.679 1.68c0 .925-.753 1.679-1.68 1.679m-4.908-7.227h2.691c.038 0 .074.014.102.041a.14.14 0 0 1 .04.102c-.038 2.25-2.256 2.61-2.278 2.613a.114.114 0 0 1-.021.001h-2.844a.142.142 0 0 1-.14-.153c.19-2.256 2.427-2.6 2.45-2.604m.887-2.728c-6.856 0-7.79 3.04-8.217 8.207-.551 6.669 1.874 8.114 8.217 8.114 6.342 0 8.767-1.445 8.216-8.114-.427-5.166-1.36-8.207-8.216-8.207z",
    fill: "#27262A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.993 14.492a.956.956 0 1 0 0 1.912.956.956 0 0 0 0-1.912",
    fill: "#404041"
  }))));
};
export default SvgD28SocialNavercafe;